import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import type { CustomerDto } from "@yalana/contracts";
import { useAuth } from "../../features/auth";
import { RouteError } from "../../shared/components/RouteError";
import { RoutePending } from "../../shared/components/RoutePending";
import { customersQueries } from "../../shared/queries/customers.queries";

export const Route = createFileRoute("/app/$customer")({
  beforeLoad: async ({ params, context, location }) => {
    const auth = context.auth;

    if (!auth.loading && !auth.user) {
      throw redirect({ to: "/login" });
    }

    if (params.customer === "belora-mobility") {
      const newPathname = location.pathname.replace(
        /\/belora-mobility(\/|$)/,
        "/ikos$1",
      );
      throw redirect({
        href: newPathname + location.searchStr,
        replace: true,
      });
    }

    if (auth.user) {
      const customers = await context.queryClient.ensureQueryData(
        customersQueries.list(),
      );
      const customer = customers.find((t) => t.slug === params.customer);

      if (!customer) {
        throw redirect({ to: "/" });
      }

      return { customer };
    }
  },
  component: CustomerLayout,
  errorComponent: ({ error }) => <RouteError error={error} />,
  pendingComponent: RoutePending,
});

function CustomerLayout() {
  const context = Route.useRouteContext();
  const { loading } = useAuth();

  const customer =
    "customer" in context
      ? (context as { customer: CustomerDto }).customer
      : null;

  if (!customer || loading) {
    return <RoutePending />;
  }

  return <Outlet />;
}
